/**
 * Wellnosh — Auto free-gift sync for Shapes theme (Switch Themes) cart drawer & cart page.
 *
 * Fill in the 3 variant IDs below (Admin → Products → Free Gift → each variant → copy ID from URL).
 * Include this file in theme.liquid before </body>:
 *   <script src="{{ 'cart-gifts.js' | asset_url }}" defer></script>
 */

(function () {
  const GIFT_VARIANT_IDS = [
    49026403401984, // Free Shipping
    49026403434752, // Mystery Gift
    49026403467520  // Wellness Guide
  ];

  let syncInProgress = false;
  let pendingResync = false;

  async function fetchCart() {
    const res = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
    return res.json();
  }

  async function addGifts(missingIds) {
    await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items: missingIds.map((id) => ({
          id,
          quantity: 1,
          properties: { _hidden_gift: 'true' }
        }))
      })
    });
  }

  async function removeGifts(giftLineItems) {
    for (const item of giftLineItems) {
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: item.key, quantity: 0 })
      });
    }
  }

  // Tells the Shapes theme to re-render cart items/footer/count via Section Rendering.
  function triggerThemeCartRender() {
    document.dispatchEvent(new CustomEvent('theme:update:cart'));
  }

  async function syncGifts() {
    if (syncInProgress) {
      pendingResync = true;
      return;
    }
    syncInProgress = true;

    try {
      const cart = await fetchCart();
      const cartVariantIds = cart.items.map((i) => i.variant_id);
      const hasRealItems = cart.items.some((i) => !GIFT_VARIANT_IDS.includes(i.variant_id));

      let changed = false;

      if (hasRealItems) {
        const missing = GIFT_VARIANT_IDS.filter((id) => !cartVariantIds.includes(id));
        if (missing.length) {
          await addGifts(missing);
          changed = true;
        }
      } else {
        const giftLineItems = cart.items.filter((i) => GIFT_VARIANT_IDS.includes(i.variant_id));
        if (giftLineItems.length) {
          await removeGifts(giftLineItems);
          changed = true;
        }
      }

      if (changed) {
        triggerThemeCartRender();
      }
    } catch (err) {
      console.error('[cart-gifts] sync failed:', err);
    } finally {
      syncInProgress = false;
      if (pendingResync) {
        pendingResync = false;
        syncGifts();
      }
    }
  }

  // Fires after any successful add-to-cart (PDP form, quick-add, sticky bar, etc.)
  document.addEventListener('theme:product:add', async (e) => {
    // Wait for the theme's own cart state to settle first.
    await e.detail.cartPromise;
    syncGifts();
  });

  // Fires when a line item's quantity changes or it's removed — covers the
  // "customer removes the last real product, gifts should disappear" case.
  document.addEventListener('theme:line-item:change', () => {
    syncGifts();
  });

  // Safety net: also sync on page load, in case cart already has real items
  // but is missing gifts (e.g. gifts manually removed, or added via a channel
  // that doesn't fire theme:product:add, like a cart page quantity bump).
  document.addEventListener('DOMContentLoaded', syncGifts);
})();